'use strict';

var Marquee = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_marquee',
		el_to_move: null,
		speed: 3,
		pause_on_hover: true,
		dynamic_size: false,
		scroll_more_on_mouse: false,
		duplicates: 0
	},

	initialize: function initialize(_element, options) {
		this.setOptions(options);
		this._element = _element || document.getElement('.' + this.options.cls);

		if (this._element) {
			this.build();
		}
	},

	build: function build() {
		this.active = true;
		var fcls = '.' + this.options.cls;

		this._el_to_marquee = this._element.getElement(fcls + '_element') || this._element.getElement(this.options.el_to_move);
		this._el_to_marquee.setStyles({
			'width': 10000,
			'position': 'relative',
			'left': 0
		});

		var srcs = [];

		this._el_to_marquee.getElements('img').each(function (_el) {
			var src = _el.getAttribute('data-src') || _el.get('src');

			srcs.push(src);
		});

		this.duplicate();

		if (srcs.length > 0) {
			new Asset.images(srcs, {
				onComplete: function () {
					this.marquee();
				}.bind(this)
			});
		} else {
			this.marquee();
		}

		this.add_events();
	},

	marquee: function marquee() {
		var self = this;
		var _marquee = this._el_to_marquee;

		this._frames = this._el_to_marquee.getChildren();

		this.set_frames();

		var w = 0;

		this._frames.each(function (_el) {
			w += _el.getSize().x;
		});

		_marquee.setStyle('width', w);

		this._element.setStyle('height', this._frames[0].getSize().y);

		this._element.fade('show');

		if (this.options.dynamic_size) {
			this.resize_frames();

			window.addEvent('resize', function () {
				self.resize_frames();
			});
		}

		this.set_timer();
	},

	set_timer: function set_timer() {
		this.timer = this.move_it.periodical(1 / this.options.speed * 200, this);
	},

	stop_timer: function stop_timer() {
		clearInterval(this.timer);
	},

	move_it: function move_it() {
		if (!this.is_visible()) return;

		this.left = this.left || 0;
		this.left = this.left - 2;

		this._el_to_marquee.setStyle('left', this.left);

		var _first = this._el_to_marquee.getFirst();
		var size = _first.getSize().x;

		if (this.left <= size * -1) {
			_first.inject(this._el_to_marquee);
			this.left = 0;
			this._el_to_marquee.setStyle('left', this.left);
		}
	},

	set_frames: function set_frames() {
		this._frames.each(function (_el) {
			_el.setStyle('float', 'left');
		});
	},

	resize_frames: function resize_frames() {
		var width = this._element.getSize().x;

		this._frames.each(function (_el) {
			_el.setStyle('width', width);
		});

		this._el_to_marquee.setStyle('width', width * this._frames.length);
	},

	add_events: function add_events() {
		var self = this;

		if (this.options.scroll_more_on_mouse) {
			var inside = false;
			var one_set_width = this._el_to_marquee.getSize().x / (this.options.duplicates + 1);

			$(document.body).addEvents({
				'mousewheel': function mousewheel(e) {
					if (e.target !== self._element && !e.target.getParent('.' + self.options.cls) || !self.stop_scroll) return;

					e.preventDefault();

					if (e.wheel < 0) {
						self.left = self.left - 100;
					} else if (e.wheel > 0) {
						self.left = self.left + 100;

						if (self.left > 0) {
							var _last = self._el_to_marquee.getLast();

							_last.inject(self._el_to_marquee, 'top');
							self.left -= _last.getSize().x;
						}
					}

					self.scroll_distance = self.scroll_distance + e.wheel * -100 || 0;

					if (self.scroll_distance > one_set_width || self.scroll_distance < one_set_width * -1) {
						self.stop_scroll = false;
					}
				}
			});

			var current_move;

			this._element.addEvents({
				'mouseenter': function mouseenter() {
					inside = true;

					(function () {
						if (!inside) return;

						self.stop_scroll = true;
					}).delay(1000);
				},

				'mouseleave': function mouseleave() {
					inside = false;
					self.stop_scroll = false;
					self.scroll_distance = 0;
				}
				//,

				// 'touchstart': function(e){
				// 	current_move = e.client.x;
				// },

				// 'touchend': function(){
				// 	current_move = null;
				// },

				// 'touchmove': function(e){
				// 	alert(current_move + ' ... ' + e.client.x);

				// 	// if(current_move){
				// 	// 	self.left += (current_move + e.client.x);
				// 	// }

				// 	current_move = e.client.x;

				// 	// $(document.body).fireEvent('mousewheel', e);
				// }
				// ,

				// 'mousemove': function(e){
				// 	console.log(e);
				// }
			});
		}

		if (this.options.pause_on_hover) {
			this._el_to_marquee.addEvents({
				'mouseover': function mouseover() {
					self.stop_timer();
				},

				'mouseout': function mouseout() {
					self.set_timer();
				}
			});
		}
	},

	duplicate: function duplicate() {
		if (this.options.duplicates < 1) return;

		var _children = this._el_to_marquee.getChildren();

		for (var i = 0; i < this.options.duplicates; i++) {
			_children.each(function (_el) {
				_el.clone().inject(this._el_to_marquee);
			}.bind(this));
		}
	},

	is_visible: function is_visible() {
		var top = this._element.getPosition().y;
		var scroll = window.getScroll().y;
		var size = this._element.getSize().y;
		var win_size = window.getSize().y;

		return top + size - scroll > 0 && scroll + win_size - top > 0;
	}
});
'use strict';

var Streetview = new Class({
	Implements: [Options, Events],

	options: {
		cls: "w_streetview",
		container: null,
		zoomControl: true
	},

	initialize: function initialize(element, options) {
		this.setOptions(options);
		this._element = element;

		if (this._element) {
			Core.load_google_api(this.build.bind(this));
		}
	},

	build: function build() {
		var _self = this._element,
		    opts = this.options,
		    cls = opts.cls;

		this.mode = 'webgl';
		this.check_webgl();

		var _config = _self.getElement('.' + cls + '_config');
		var _pano = this._pano = _self.getElement('.' + cls + '_pano');

		if (_pano && _config) {
			var config = this.config = JSONMOO.decode(_config.get('text').toString().trim(), false);
			config.mode = this.mode;

			if (!config.position && config.lat && config.lng) {
				config.position = new google.maps.LatLng(config.lat, config.lng);
			}

			var default_config = {
				position: new google.maps.LatLng(40.7642676, -73.9741554),
				addressControl: false,
				scrollwheel: false,
				fullscreenControl: false,
				zoomControl: opts.zoomControl
			};

			var final_config = Object.merge(default_config, config);
			var service = this.service = new google.maps.StreetViewService();

			if (final_config.pov && Object.keys(final_config.pov).length) {
				this.init_pano(final_config);
			} else {
				var panoRequest = {
					location: final_config.position,
					preference: google.maps.StreetViewPreference.NEAREST,
					radius: final_config.radius || 50,
					source: google.maps.StreetViewSource.OUTDOOR
				};
				service.getPanorama(panoRequest, function (pano_data, status) {
					if (status == google.maps.StreetViewStatus.OK) {
						var angle = this.compute_angle(final_config.position, pano_data.location.latLng);

						final_config.pov = {
							'heading': angle,
							'pitch': 0,
							'zoom': 1,
							'pano_data': pano_data
						};
					} else {
						final_config.pov = null;
					}
					this.init_pano(final_config);
				}.bind(this));
			}
		}
	},

	check_webgl: function check_webgl() {
		var canvas = new Element('canvas'),
		    contextNames = ["webgl", "experimental-webgl", "moz-webgl", "webkit-3d"],
		    gl = null;

		contextNames.each(function (e, i) {
			if (!gl) {
				try {
					gl = canvas.getContext(contextNames[i]);
				} catch (e) {}
			}
		});

		canvas = null;

		if (gl === null) this.mode = 'html4';
	},

	init_pano: function init_pano(config) {
		if (config.pov.pano_data.location.pano) {
			config.pano = config.pov.pano_data.location.pano;
		}
		var pano = this.pano = new google.maps.StreetViewPanorama(this._pano, Object.merge(config, { visible: true }));

		var marker_config = {
			'position': config.position,
			'clickable': false,
			'map': pano
		};

		if (config.marker) {
			marker_config = Object.merge(marker_config, config.marker);
		}

		this.base_marker = new google.maps.Marker(marker_config);
	},

	compute_angle: function compute_angle(end, start) {
		var DEGREE_PER_RADIAN = 57.2957795;
		var RADIAN_PER_DEGREE = 0.017453;
		var dlat = end.lat() - start.lat();
		var dlng = end.lng() - start.lng();
		var angle = Math.atan2(dlng * Math.cos(end.lat() * RADIAN_PER_DEGREE), dlat) * DEGREE_PER_RADIAN;

		if (angle >= 360) {
			angle -= 360;
		} else if (angle < 0) {
			angle += 360;
		}
		return angle;
	}
});
'use strict';

var ScrollToElement = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'scroll_to',
		offset_y: 0
	},

	initialize: function initialize(_elements, options) {
		this.setOptions(options);
		this._elements = _elements || document.getElements('.' + this.options.cls);

		if (this._elements) {
			this.build();
		}
	},

	build: function build() {
		this.setScrollTo();
	},

	setScrollTo: function setScrollTo() {
		var self = this;

		var myFx = new Fx.Scroll(window, {
			offset: {
				x: 0,
				y: self.options.offset_y,
				duration: 1000
			},
			onStart: function onStart() {
				$(window).fireEvent('jumpStart');
			},
			onComplete: function onComplete() {
				$(window).fireEvent('jumpStop');
			}

		});

		this._elements.each(function (link) {
			link.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				if (this.hasClass('_top')) {
					myFx.toTop();
					return;
				}

				var name = (this.get('data-href') || this.get('href') || this.href).split('#')[1];
				var elem = $$('a[name=' + name + ']');
				myFx.toElement(elem[0], 'y');
			});
		});
	}
});
'use strict';

var Voila = new Class({
	Implements: [Options],

	options: {
		magnify: 1.5,
		add_class: '',
		animate: true,
		animation_time: 300,
		show_on: 'click', // click or mouseover
		show_full_size: false // magnify OR fullsize
	},

	initialize: function initialize(options) {
		this.setOptions(options);

		var events;

		if (this.options.show_on == 'click') {
			events = {
				'click': function (e) {
					if (e.target === this._opened_el) {
						return;
					}
					this.close_current();
				}.bind(this),
				'click:relay(img.w_voila)': this.handle.bind(this)
			};
		} else {
			this.options.animate = false;
			events = {
				'mouseover:relay(img.w_voila)': this.handle.bind(this)
			};
		}
		$(document.body).addEvents(events);
	},

	handle: function handle(e, _el) {
		if (_el === this._opened_el) {
			this.close_current();
			return;
		}
		this.current_voila = new Voila.Instance(_el, this.options);
		this.current_voila.addEvents({
			close: function () {
				this._opened_el = null;
			}.bind(this)
		});
		this._opened_el = _el;
	},

	close_current: function close_current() {
		if (this.current_voila) {
			this.current_voila.close();
		}
	}
});

Voila.Instance = new Class({
	Implements: [Options, Events],

	initialize: function initialize(_image, options) {
		var self = this;
		this.setOptions(options);
		this._src_image = _image;

		this._stalkerheight = document.getElement('.w_stalker').getSize().y;

		this._element = new Element('div', {
			class: 'w_voila_e' + this.options.add_class
		}).inject(document.body);

		var _img_clone = _image.clone();
		_img_clone.set('class', '');
		this._element.adopt(_img_clone);
		this.add_spinner();
		this._image = this._element.getElement('img');
		this.set_initial_state(_image);

		if (this.options.animate) {
			this.animate = true;
			this.add_animation();
		}

		if (this.options.show_on == 'mouseover') {
			this._src_image.getParent().addEvents({
				mouseenter: function mouseenter() {
					self.in_image = true;
				},
				mouseleave: function mouseleave() {
					self.in_image = false;
					(function () {
						if (!self.in_element) {
							self.close();
						}
					}).delay(50);
				}
			});
			this._element.addEvents({
				mouseenter: function mouseenter() {
					self.in_element = true;
				},
				mouseleave: function mouseleave() {
					self.in_element = false;
					(function () {
						if (!self.in_image) {
							self.close();
						}
					}).delay(50);
				}
			});
		}
		this._element.addClass('_loading');
		if (this.options.show_full_size) {
			var src = _image.getAttribute('data-full-src');
			new Asset.image(src, {
				onLoad: function () {
					this._image.set('src', src);

					var availableHeight = window.getSize().y - this._stalkerheight - 40; // 40px of margin
					var newHeight = this._image.naturalHeight;
					var newWidth = this._image.naturalWidth;
					if (availableHeight < this._image.naturalHeight) {
						newHeight = availableHeight;
						newWidth = availableHeight * this._image.naturalWidth / this._image.naturalHeight;
					}

					this.open_size = {
						x: newWidth,
						y: newHeight
					};
					this._element.removeClass('_loading');
					this.open();
				}.bind(this)
			});
		} else {
			this.open_size = {
				x: _image.getSize().x * this.options.magnify,
				y: _image.getSize().y * this.options.magnify
			};
			this._element.removeClass('_loading');
			this.open();
		}
	},

	add_spinner: function add_spinner() {
		var spinner_opts = {
			lines: 12, // The number of lines to draw
			length: 7, // The length of each line
			width: 3, // The line thickness
			radius: 8, // The radius of the inner circle
			corners: 1, // Corner roundness (0..1)
			rotate: 0, // The rotation offset
			direction: 1, // 1: clockwise, -1: counterclockwise
			color: '#000', // #rgb or #rrggbb or array of colors
			speed: 2, // Rounds per second
			trail: 60, // Afterglow percentage
			shadow: false, // Whether to render a shadow
			hwaccel: false, // Whether to use hardware acceleration
			className: 'spinner', // The CSS class to assign to the spinner
			zIndex: 1, // The z-index (defaults to 2000000000)
			position: 'absolute',
			bottom: 25,
			right: 25
		};
		this.spinner = new Spinner(spinner_opts).spin(this._element);
	},

	set_initial_state: function set_initial_state(_image) {
		var pt = this._element.getStyle('padding-top').toInt() + this._element.getStyle('border-top-width').toInt();
		var pl = this._element.getStyle('padding-left').toInt() + this._element.getStyle('border-left-width').toInt();

		this.init_pos = {
			x: _image.getPosition().x - pl,
			y: _image.getPosition().y - pt
		};

		this.init_size = {
			x: _image.getSize().x,
			y: _image.getSize().y
		};

		this._element.setStyles({
			left: this.init_pos.x,
			top: this.init_pos.y
		});

		this._image.setStyles({
			height: _image.getSize().y,
			width: _image.getSize().x
		});
	},

	add_animation: function add_animation() {
		this.fx_e = new Fx.Morph(this._element, {
			link: 'cancel',
			duration: this.options.animation_time,
			transition: Fx.Transitions.linear
		});

		this.fx_i = new Fx.Morph(this._image, {
			link: 'cancel',
			duration: this.options.animation_time,
			transition: Fx.Transitions.linear
		});
	},

	open: function open() {
		var element_syles;

		if (this.options.show_full_size) {
			element_syles = {
				left: (window.getSize().x - this.open_size.x) / 2 + document.body.getScroll().x,
				top: (window.getSize().y - this._stalkerheight - this.open_size.y) / 2 + document.body.getScroll().y + this._stalkerheight
			};
		} else {
			element_syles = {
				left: this.init_pos.x - (this.open_size.x - this.init_size.x) / 2,
				top: this.init_pos.y - (this.open_size.y - this.init_size.y) / 2
			};
		}

		var image_syles = {
			width: this.open_size.x,
			height: this.open_size.y
		};

		if (this.animate) {
			this.fx_e.start(element_syles);
			this.fx_i.start(image_syles);
		} else {
			this._element.setStyles(element_syles);
			this._image.setStyles(image_syles);
		}
	},

	close: function close() {
		var self = this;
		var element_syles = {
			left: this.init_pos.x,
			top: this.init_pos.y
		};
		var image_syles = {
			width: this.init_size.x,
			height: this.init_size.y
		};

		if (this.animate) {
			this.fx_e.start(element_syles);
			this.fx_i.start(image_syles).chain(function () {
				self._element.dispose();
			});
		} else {
			this._element.setStyles(element_syles);
			this._image.setStyles(image_syles);
			this._element.dispose();
		}
		this.fireEvent('close');
	}
});
'use strict';

var BlimpExtMap = new Class({
	Extends: BlimpExt,

	post_process: function post_process() {
		var title = this._link.getAttribute('data-title');
		if (this._element.getElement('.map_title')) this._element.getElement('.map_title').set('html', title);

		if (!this.map) {
			this.create_map();
		}

		//this.addEvent('hide', this.self_destruct.bind(this));

		this.parent();
	},

	create_map: function create_map() {
		var self = this;
		var rpc = this._link.getAttribute('data-rpc-map');
		var _map_container = this._element.getElement('.map_container');

		_map_container.empty();

		var _map = new Element('div', {
			'class': 'map'
		}).inject(_map_container);

		self.remote = new Remote({
			rpc: rpc,
			method: 'get',
			onSuccess: function onSuccess() {
				var data = this.get_data();
				self.map = new SimpleMap(_map, {
					zoom: data.ini.zoom,
					max_zoom: 17,
					min_zoom: 10,
					lat: data.ini.lat,
					lng: data.ini.lng,
					street_view_control: true,
					onMapReady: function onMapReady() {
						this.add_marker({
							lat: data.ini.lat,
							lng: data.ini.lng,
							icon: data.ini.markers_path + 'base.png',
							bubble_content: data.base_location.name
						});
					}
				});
			}
		});
	},

	self_destruct: function self_destruct() {
		Core.destruct(this.remote, this);
		Core.destruct(this.map, this);
	}
});
'use strict';

var BlimpExtPricehistory = new Class({
	Extends: BlimpExt,

	post_process_build: function post_process_build() {
		var _table = this._element.getElement('.w_pricehistory_table') || this._element.getElement('.w_pricehistory_fullscreen_table');;
		var tbody = _table.getElement('.tbody');

		if (this.is_initialized) {
			return;
		}

		if (this.options.page === 'lst' || this.options.vscroll) {
			new StyledScroll(tbody, {
				type: 'v',
				max_height: 300
			});
		}

		var _diagram = this._element.getElement('.diagram');

		if (_diagram) {
			_diagram.setStyle('height', _table.getSize().y);

			var data = JSONMOO.decode(_diagram.get('html'), false);

			_diagram.set('html', '');

			new Phgraph(_diagram, {
				'size': 'small',
				'data': data.reverse() // need to reverse the order so it will be display properly in the chart
			});
		}

		this.parent();
		this.is_initialized = true;
	}

});
'use strict';

var Tabscroll = new Class({
	Implements: [Options, Events],
	options: {
		cls: 'w_tabscroll'
	},

	initialize: function initialize(_element, options) {
		this._element = document.id(_element);

		if (this._element) {
			this.setOptions(options);
			this.build();
		}
	},

	build: function build() {
		var fcls = '.' + this.options.cls;
		var _element = document.id(this);

		this._tabs = _element.getElements(fcls + '_tabs li');
		this._content = _element.getElement(fcls + '_content');
		this._strip = _element.getElement(fcls + '_strip');
		this._items = _element.getElements(fcls + '_item');
		this.fx_items = [];

		this.active_index = 0;

		if (!this._items || this._items.length == 0) {
			this._element.dispose();
			return;
		}

		this.fx_scroll = new Fx.Scroll(this._content, {
			duration: 500,
			link: 'cancel'
		});

		this._tabs.each(function (_el, i) {
			_el.addEvent('click', this.select.bind(this, _el, i));

			if (this._tabs.length == 1) {
				_el.addClass('_full_width');
			} else if (i == 0) {
				_el.addClass('_first');
			} else if (i == this._items.length - 1) {
				_el.addClass('_last');
			}

			this.fx_items.push(new Fx.Morph(this._items[i], {
				duration: 1000,
				link: 'cancel'
			}));

			if (_el.hasClass('active') && i > 0 && this._items.length > 1) {
				this.select(_el, i);
			}
		}.bind(this));
	},

	select: function select(_tab, i, e) {
		if (e && e.stop) e.stop();

		if (this.active_index == i) return;

		this._tabs[this.active_index].removeClass('active');
		this.active_index = i;

		this._tabs[i].addClass('active');
		this.fx_scroll.toElement(this._items[i]);

		this.fx_items[i].start({
			opacity: [0, 1]
		});

		this.fireEvent('tabchange', i);
	},

	toElement: function toElement() {
		return this._element;
	}
});
'use strict';

var Schools = new Class({
	Implements: [Events, Options],
	options: {
		cls: 'w_schools',
		customId: 'schools'
	},

	initialize: function initialize(element, options) {
		this.setOptions(options);
		this._element = element;

		if (this._element) this.build();
	},

	build: function build() {
		var self = this;
		var rpc = this._element.get('data-rpc');

		if (rpc) {
			var remote = new Request.HTML({
				url: rpc,
				onSuccess: function onSuccess(a, b, c, d) {
					if (c === "") {
						self._element.getParent().dispose();
						return;
					}

					this.data = c;
					self._element.set('html', this.data);

					new Tabscroll(self.options.customId);

					var _shrinkers = self._element.getElements('.w_shrinker');

					_shrinkers.each(function (_shrinker) {
						var min_height = 270;

						new Shrinker(_shrinker, {
							min_height: min_height,
							toggler: _shrinker.getParent('.w_tabscroll_item').getElement('.w_shrinker_head'),
							single_opened: false,

							onShrink: function onShrink() {
								this._toggler.removeClass('_opened');
								this._toggler.set('html', '<span class="w_shrinker_button">Show more</span>');
							},

							onUnshrink: function onUnshrink() {
								this._toggler.addClass('_opened');
								this._toggler.set('html', '<span class="w_shrinker_button">Show less</span>');
							}
						});
					});
				},

				onFailure: function onFailure() {
					self._element.getParent().dispose();
				}
			});

			remote.get();
		}
	}
});
'use strict';

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [LazyLoader]
...
*/
var ColumnChart = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_columnchart',
		max_value: 0,
		increment: 100, //increment of the scale
		height: 500, //it's not a total height of the chart, it's height of it's scale
		disp_col: 5, //amount of displayed columns
		scroll_speed: 300,
		animate_values: true,
		scroll_at_a_time: 3, //how many items scroll at a time
		y_axis: '', //displayed name of y axis
		hscroll: true,
		zebra: true, //zebra background
		has_images: true,
		main_item_indicator: false, //horisontal dashed line
		scale_px_increment: 30,
		data: null,
		isBuilding: false,
		missingImage: null
	},

	initialize: function initialize(_element, options) {
		this.setOptions(options);

		this._element = _element || document.getElement('.' + this.options.cls);
		this._element.addClass('_loading');

		if (this._element) {
			this.build();
		}
	},

	build: function build() {
		var opts = this.options;

		if (Core.is_ie8()) {
			this._element.addClass('ie');
		}

		this.max_value = opts.max_value;

		if (opts.y_axis != '') {
			this._y_axis = new Element('.y_axis', { 'html': '<div class="vertical_text">' + opts.y_axis + '</div>' }).inject(this._element);
		}

		this._chart = new Element('.chart').inject(this._element);

		if (opts.zebra) {
			this._zebra = new Element('.zebra').inject(this._chart);
		}

		this._scroller = new Element('.scroller').inject(this._chart);

		this._col_container = new Element('.col_container').inject(this._scroller);

		this.property = this._element.getProperty('data-property');
		this.y_axis_text = this._element.getProperty('data-yaxis-name');

		if (opts.data) {
			this.data = opts.data;
			this.process_rpc();
		} else {
			this.rpc_request();
		}

		this.add_functionalities();
	},

	add_hscroll: function add_hscroll() {
		var self = this;
		var opts = this.options;
		var _hscroll = this._hscroll = new Element('.hscroller', { 'html': '<div class="ar_l">&nbsp;</div><div class="dragger">|||</div><div class="ar_r">&nbsp;</div>' });
		_hscroll.inject(this._chart);

		this._element.addClass('_has_dragger');

		var _ar_l = this._ar_l = _hscroll.getElement('.ar_l');
		var _ar_r = this._ar_r = _hscroll.getElement('.ar_r');

		_ar_l.addEvent('click', function () {
			self._arr_prev.fireEvent('click');
		});

		_ar_r.addEvent('click', function () {
			self._arr_next.fireEvent('click');
		});

		var _dragger = this._dragger = _hscroll.getElement('.dragger'),
		    size_coefficient = this._items.length - opts.disp_col;

		this.dragger_fx = new Fx.Morph(_dragger, {
			link: 'cancel',
			duration: 1000,
			transition: Fx.Transitions.linear
		});

		if (size_coefficient > 20) {
			size_coefficient = 20;
		} else if (size_coefficient < 2) {
			size_coefficient = 2;
		}

		var dr_size = _hscroll.getSize().x / size_coefficient;

		_dragger.setStyle('width', dr_size);

		var max_left = self.dragger_max_left = _hscroll.getSize().x - dr_size,
		    dragger_left = max_left / (this._items.length - opts.disp_col) * this.current_col;

		if (this.current_col == 0) {
			_ar_l.addClass('inactive');
		} else if (this.current_col == this.last) {
			_ar_r.addClass('inactive');
		}

		(function () {
			self.dragger_fx.start({ 'left': dragger_left });
			self.dragger_fx.setOptions({ duration: self.options.scroll_speed });
		}).bind(this).delay(2000);

		_hscroll.addEvents({
			'mouseenter': function mouseenter() {
				if (self.dragging != true) self._element.addClass('dragging');
			},
			'mouseleave': function mouseleave() {
				if (self.dragging != true) self._element.removeClass('dragging');
			}
		});

		_dragger.addEvent('mousedown', function (e) {
			self.dragging = true;
			self._element.addClass('dragging');
			dragger_left = _dragger.getStyle('left').toInt();
			self.init_pos = e.page.x;
			return false;
		});

		$(document.body).addEvents({
			'mousemove': function mousemove(e) {
				if (self.dragging) {
					var hmove = e.page.x - self.init_pos,
					    left = dragger_left + hmove;

					if (left < 0) {
						left = 0;
					} else if (left > max_left) {
						left = max_left;
					}

					_dragger.setStyle('left', left);

					var area = self.drag_area = (left / (max_left / (self._items.length - opts.disp_col))).round();

					self.animate.set(left * ((self._col_container.getSize().x - self.scr_width) / max_left), 0);

					if (self.current_col != area) {
						self.current_col = area;

						if (area == 0) {
							self._arr_prev.addClass('inactive');
							_ar_l.addClass('inactive');
						} else {
							self._arr_prev.removeClass('inactive');
							_ar_l.removeClass('inactive');
						}

						if (area == self._items.length - opts.disp_col) {
							self._arr_next.addClass('inactive');
							_ar_r.addClass('inactive');
						} else {
							self._arr_next.removeClass('inactive');
							_ar_r.removeClass('inactive');
						}
					}

					self.hide_locked_item();
				}
			},

			'mouseleave': function mouseleave() {
				self.dragging = false;
				self._element.removeClass('dragging');
			},

			'mouseup': function mouseup() {
				self.dragging = false;
				self._element.removeClass('dragging');
			}
		});
	},

	create_scale: function create_scale() {
		this._scale = new Element('.scale');

		if (this._y_axis) {
			this._scale.inject(this._y_axis, 'after');
		} else {
			this._scale.inject(this._element, 'top');
		}

		var increment = this.options.increment;

		// Force the max_value to be rounded to the nearest increment
		this.max_value = Math.ceil(this.max_value / increment) * increment;

		// Calculate the number of increments that can fit into the chart height
		var numIncrements = Math.floor(this.options.height / this.options.scale_px_increment);
		increment = Math.ceil(this.max_value / numIncrements);

		var value = 0,
		    _el;

		this._values = [];

		// Adjust grid height based on the new increment value
		var grid_height = this.options.height / numIncrements;

		while (value <= this.max_value) {
			var grid_char = this.options.zebra ? '&bull;' : '-';
			var formattedValue = '$' + Core.add_commas(value);
			_el = new Element('.value', {
				'html': formattedValue + '<div class="grid">' + grid_char + '</div>',
				'styles': {
					'height': grid_height + 'px'
				}
			}).inject(this._scale, 'top');
			value += increment;

			this._values.push(_el);
		}

		this.options.height = grid_height * this._values.length;

		if (this._zebra) {
			var cls = '';
			this._values.each(function (_el, i) {
				var zebra_height = grid_height;

				if (cls == '') {
					cls = 'x';
					zebra_height -= 2; //dashed border of the zebra
				} else {
					cls = '';
				}

				var _strip = new Element('div', { 'class': cls });
				_strip.inject(this._zebra);
				_strip.setStyle('height', zebra_height);
			}.bind(this));

			var margin = this._scale.getElement('.grid').getCoordinates().top - this._chart.getCoordinates().top - this._scale.getElement('.grid').getStyle('margin-top').toInt();
			this._zebra.getElement('div').setStyle('margin-top', margin);
		} else {
			this._values.each(function (_el) {
				_el.setStyle('height', grid_height);
			});
		}

		var scale_height = this._scale.getSize().y - this._scale.getStyle('padding-top').toInt() + this._scale.getElement('.grid').getStyle('top').toInt();
		this._scale.setStyle('height', scale_height);

		var grid_width = this._chart.getComputedSize().computedBottom;
		this._scroller.setStyle('height', this._scale.getSize().y - grid_width);

		if (this._y_axis) {
			this._y_axis.setStyle('height', this._scale.getSize().y - grid_width);
		}

		this.set_prices();
	},

	set_prices: function set_prices() {
		var height;
		var price;

		this._items.each(function (e) {
			price = e.getAttribute('data-price').toInt();
			height = (price * this.options.height / this.max_value).round() - 1;

			if (this.options.animate_values == true) {
				e.setAttribute('data-height', height);
			} else {
				e.setStyle('height', height);
			}

			if (e.hasClass('main') && this._indicator) {
				this._indicator.setStyle('bottom', height).addClass('visible');
			}
		}.bind(this));
	},

	rpc_request: function rpc_request() {
		var self = this;

		if (!self.options.data) {
			new Remote({
				rpc: this._element.getAttribute('data-rpc'),
				method: 'get',
				onSuccess: function onSuccess() {
					self.data = this.get_data();
					self.process_rpc();

					document.fireEvent('columnChartLoaded');
				},
				onError: function onError() {
					this._element.set('html', 'Server connection error. Please try later');
				}
			});
		} else {
			self.process_rpc();
		}
	},

	process_rpc: function process_rpc() {
		this._items = [];
		var col_container_width = 0;

		if (this.data && this.data != '') {
			this.change_y_label();

			var notFoundImageUrls = ['/l/not-found-grey-gallery-1.png', '/l/not-found-grey-gallery-2.png', '/l/not-found-grey-gallery-3.png', '/l/not-found-grey-gallery-4.png', '/l/not-found-grey-gallery-5.png', '/l/not-found-grey-gallery-6.png', '/l/not-found-grey-gallery-7.png', '/l/not-found-grey-gallery-8.png'];
			var notFoundImageCnt = 0;

			this.data.each(function (e, i) {

				if (!e.thumbor_images || !!e.thumbor_images && e.thumbor_images.length == 0) {
					var _index = notFoundImageCnt % 8;
					e.notFoundImageUrl = Res_i + notFoundImageUrls[_index];
					notFoundImageCnt++;
				}

				var price = e[this.property];

				price = price.toInt();

				if (this.max_value < price) {
					this.max_value = price;
				}

				var img_path,
				    name = (e.name || e.address || e.building_name || e.building_address) + (e.unit ? ', #' + e.unit : ''),
				    cls = 'bld_item' + (e.current == true ? ' main' : ''),
				    html = '';

				if (e.current == true && this.options.main_item_indicator) {
					this._indicator = new Element('.indicator', { 'html': '<div class="pointer">&nbsp;</div>' }).inject(this._chart).fade('hide');
				}

				if (this.options.has_images) {
					img_path = this.options.tmp_img || e.image;

					html = '<img src="' + img_path + '"' + 'onerror="' + this.options.err_img + '"' + '/>';
				}
				var vt_html = '<div class="vt_container">' + '<div class="vertical_text">' + name + '</div>' + '</div>';

				var add_cls = this._element.getAttribute('data-open') && this._element.getAttribute('data-open') == 'page' ? '' : ' w_blimp_bld';

				var _bld_item = new Element('div', {
					'class': cls + add_cls,
					'html': html,
					'data-price': e[this.property],
					'data-class': 'w_blimp_bld'
				});

				this._items.push(_bld_item);

				_bld_item.addEvents({
					'mouseenter': function () {
						if (this.locked_item) {
							this.locked_item.removeClass('_active');
						}

						this.locked_item = _bld_item;
						this.locked_item.addClass('_active');
						this.bulb_show(e, _bld_item);
					}.bind(this)
				});

				// if(e.url_listing || e.url && e.url != ''){
				// 	_bld_item.set('data-rpc', e.url_listing || e.url);

				// 	if (this._element.getAttribute('data-open') && this._element.getAttribute('data-open') == 'page'){
				// 		_bld_item.addEvent('click', function(){ window.location = e.url_listing || e.url; });
				// 	}else{
				// 		new BlimpExt(_bld_item, {
				// 			draggable: true,
				// 			show_veil: true,
				// 			onPostRpc: function(){
				// 				new BldBlimp(this);
				// 			}
				// 		});
				// 	}
				// }

				var _column = new Element('div', {
					'class': 'column' + (i == this.data.length - 1 ? ' last' : ''),
					'html': vt_html
				}).adopt(_bld_item).inject(this._col_container);

				var col_w = _column.getComputedSize().width,
				    col_m = _column.getStyle('margin-right').toInt();

				col_container_width += col_w + col_m;

				if (!this.scroll_w_is_set) {
					this.set_scroll_width(col_w, col_m);
					this.scroll_w_is_set = true;
				}
			}.bind(this));

			(function () {
				this._col_container.setStyle('width', col_container_width);
			}).delay(500, this);

			this._main_col = this._scroller.getElement('.main');

			if (this._main_col) {
				this._init_scroll = this._main_col.getParent('.column');
			} else {
				//this.fireEvent('notEnoughData');
			}

			this.create_scale();

			if (this._scroller.getStyle('width').toInt() < col_container_width) {
				this.add_scrolling();
			}

			if (this.options.animate_values == true) {
				this.animate_prices();
			} else {
				if (this._indicator && this._indicator.hasClass('visible')) {
					this._indicator.fade('show');
				}
			}

			this._bulb = new Element('.' + this.options.cls + '_bulb', {
				'html': '<div class="pointer">&nbsp;</div>'
			}).inject(this._element);

			this._bulb.addClass('clearfix');

			if (!this.options.isBuilding) {
				this._bulb.addClass('_listings');
			} else {
				this._bulb.addClass('_buildings');
				this._info = new Element('div.info').inject(this._bulb, 'top');

				var content = this._info;
				this._bulb_name = new Element('a.name').inject(content);
				this._bulb_address = new Element('a.address').inject(content);
				this._bulb_details = new Element('span.details').inject(content);
				this._bulb_available_for_sale = new Element('a.apts_for_sale').inject(content);
				this._bulb_available_for_rent = new Element('a.apts_for_rent').inject(content);
				this._bulb_size = new Element('span.size').inject(content);
				this._bulb_created = new Element('span.created').inject(content);
				this._bulb_updated = new Element('span.updated').inject(content);
				var grey_box = new Element('div.grey-box').inject(content);
				this._bulb_price = new Element('span.price').inject(grey_box);
				this._bulb_sales = new Element('span.sales').inject(grey_box);
			}

			this._chart.setStyle('visibility', 'visible');

			if (this._y_axis) {
				this._y_axis.setStyle('visibility', 'visible');
			}
		} else {
			this.fireEvent('noData');
		}

		this._element.removeClass('_loading');
	},

	change_y_label: function change_y_label() {
		if (!this._y_axis) return;

		this._y_axis.getElement('.vertical_text').set('html', this.y_axis_text);
	},

	set_scroll_width: function set_scroll_width(w, m) {
		var dc = this.options.disp_col,
		    width = this.scr_width = w * dc + m * (dc - 1) - 100;

		this._scroller.setStyle('width', width);
	},

	bulb_show: function bulb_show(data, _el) {
		if (this._save_tooltip) {
			this._save_tooltip.hide();
		}
		if (this.bubble_is_ready && this.dragging != true) {
			if (!this.options.isBuilding) {
				this.add_listing_tile(data);
			} else {

				var add_text = this.property == 'ppsqft' || this.property == 'sqft' ? ' /ft<sup>2</sup>' : '';
				var price = data[this.property];

				var transactions = data.transactions || 0;
				var str_sales = transactions > 1 ? 'sales' : 'sale';

				this._bulb_sales.set('html', 'Based on ' + transactions + ' ' + str_sales + '<br/>in past 12 months');

				if (data.sale && data.sale.available > 0) {
					var apts = data.sale.available > 1 ? ' Apartments' : ' Apartment';
					if (data.sale.min == data.sale.max) {
						this._bulb_available_for_sale.set('html', '<strong>' + data.sale.available + apts + ' for Sale</strong> for $' + Core.short_number(data.sale.min));
					} else {
						this._bulb_available_for_sale.set('html', '<strong>' + data.sale.available + apts + ' for Sale</strong> ($' + Core.short_number(data.sale.min) + ' - $' + Core.short_number(data.sale.max) + ')');
					}
					this._bulb_available_for_sale.removeEvents().addEvent('click', function (e) {
						e.stopPropagation();
						Cookie.write('crBovJumpTo', 'sale');
						window.location = data.building_url;
					});
				} else {
					this._bulb_available_for_sale.set('html', '');
				}

				if (data.rent && data.rent.available > 0) {
					var apts = data.rent.available > 1 ? ' Apartments' : ' Apartment';
					if (data.rent.min == data.rent.max) {
						this._bulb_available_for_rent.set('html', '<strong>' + data.rent.available + apts + ' for Rent</strong> for $' + Core.add_commas(data.rent.min));
					} else {
						this._bulb_available_for_rent.set('html', '<strong>' + data.rent.available + apts + ' for Rent</strong> ($' + Core.add_commas(data.rent.min) + ' - $' + Core.add_commas(data.rent.max) + ')');
					}
					this._bulb_available_for_rent.removeEvents().addEvent('click', function (e) {
						e.stopPropagation();
						Cookie.write('crBovJumpTo', 'rent');
						window.location = data.building_url;
					});
				} else {
					this._bulb_available_for_rent.set('html', '');
				}

				this._bulb_price.set('html', '$' + Core.add_commas(price) + add_text);
				this._bulb_name.set('text', (data.name || data.address || data.building_name || data.building_address) + (data.unit ? ', #' + data.unit : ''));
				this._bulb_name.set('href', data.url_listing || data.url || data.building_url);

				if (data.sqft) {
					this._bulb_size.set('html', 'Approx. ' + data.sqft + ' ft<sup>2</sup>');
				}
				// if (data.listing_added) {
				// 	this._bulb_created.set('text', 'Listed ' + data.listing_added);
				// }
				// if (data.listing_updated) {
				// 	this._bulb_updated.set('text', 'Updated ' + data.listing_updated);
				// }

				if (data.name || data.building_name) {
					if (data.address || data.building_address) {
						this._bulb_address.set('text', data.address || data.building_address);
					}
					if (data.url || data.building_url) {
						this._bulb_address.set('href', data.url_listing || data.url || data.building_url);
					}
					this._bulb_address.show();
				} else {
					this._bulb_address.hide();
				}

				if (this.options.isBuilding) {
					this._bulb.set('data-class', 'w_blimp_bld');
					this._bulb.set('href', data.url);

					new BlimpExt(this._bulb, {
						draggable: true,
						show_veil: true,
						onPostRpc: function onPostRpc() {
							new BldBlimp(this);
						}
					});
				}

				if (this._bulb_ppsqft && data["ppsqft"] != null) {
					this._bulb_ppsqft.set('html', '$' + Core.add_commas(data["ppsqft"]) + ' /ft<sup>2</sup>');
				} else {
					if (this._bulb_ppsqft) {
						this._bulb_ppsqft.setStyle('display', 'none');
					}
				}

				this._bulb_details.set('text', data.beds_baths);
				this.add_save_support(data);
			}

			var v_pos = _el.getStyle('height').toInt() + this._bulb.getElement('.pointer').getStyle('height').toInt() + this._element.getComputedSize().computedBottom + 1 /*border*/
			,
			    h_pos = _el.getCoordinates().left - this._element.getCoordinates().left - this._bulb.getStyle('width').toInt() / 2 - this._bulb.getStyle('padding-left').toInt() + _el.getCoordinates().width / 2;

			this._bulb.setStyles({
				'bottom': v_pos,
				'left': h_pos > 400 ? h_pos - 160 : h_pos + 160
			});
			if (h_pos > 400) {
				this._bulb.addClass('right-bulb');
			} else {
				this._bulb.removeClass('right-bulb');
			}

			this._bulb.show();
		}
	},

	add_listing_tile: function add_listing_tile(data) {
		// for listings
		if (!this.options.isBuilding) {
			if (this.listingTile) {
				// dont do anything if the user mouseover to the last active listing again
				if (this.listingTile.hasClass('_' + data.mask_id)) {
					return;
				}

				// remove the current save button
				this.listingTile.dispose();
			}

			if (data.listingTile) {
				data.listingTile.inject(this._bulb);
			} else {
				data.contact = '';
				data.listingTile = new Element('<cr-listing-tile', {
					'class': 'cr-listing-tile' + ' _' + data.mask_id,
					'data-rpc': data.url_v2,
					'data-open-blimp-on-click': true,
					'data-missing-image': this.options.missingImage,
					'data-rpc-save-to-profile': this.options.rpcSaveToProfile,
					'html': '<div class="hidden none obj-wrapper">' + JSONMOO.encode(data) + '</div>'
				}).inject(this._bulb);

				Core.compile_html(data.listingTile);
			}

			this.listingTile = data.listingTile;
		}
	},

	add_save_support: function add_save_support(data) {
		if (this.currentSaveButton) {
			var id = this.options.isBuilding ? data.building_id : data.mask_id;
			// dont do anything if the user mouseover to the last active listing again
			if (this.currentSaveButton.hasClass('_' + id)) {
				return;
			}
			// remove the current save button
			this.currentSaveButton.dispose();
		}

		this.currentSaveButton = data.crSaveToProfile;
	},

	bulb_hide: function bulb_hide() {
		if (this._save_tooltip) {
			this._save_tooltip.hide();
		}
		this._bulb.hide();
	},

	add_scrolling: function add_scrolling() {
		this._arr_prev = new Element('.arr_prev');
		this._arr_next = new Element('.arr_next');

		this._columns = this._scroller.getElements('.column');
		this.current_col = 0;

		this._arr_prev.inject(this._chart);
		this._arr_next.inject(this._chart);

		this.animate = new Fx.Scroll(this._scroller, {
			link: 'cancel',
			duration: 1000,
			transition: Fx.Transitions.Quad.easeOut,
			onStart: function () {
				this.hide_locked_item();
			}.bind(this)
		});

		if (this._init_scroll) {
			this._columns.each(function (_el, i) {
				if (_el === this._init_scroll) {
					var half = Math.ceil(this.options.disp_col / 2);

					if (i < half) {
						this.current_col = 0;
						this._arr_prev.addClass('inactive');
					} else if (this._columns.length - i <= half) {
						this.current_col = this._columns.length - this.options.disp_col;
						this._arr_next.addClass('inactive');
					} else {
						this.current_col = i - half + 1;
					}
				}
			}.bind(this));
		} else {
			this._arr_prev.addClass('inactive');
			this.current_col = 0;
		}

		(function () {
			this.animate.toElement(this._columns[this.current_col]).chain(function () {
				this._arr_prev.addEvent('click', this.scroll_prev.bind(this));
				this._arr_next.addEvent('click', this.scroll_next.bind(this));
			}.bind(this));
			this.animate.setOptions({ duration: this.options.scroll_speed });
		}).bind(this).delay(2000);

		this.last = this._columns.length - this.options.disp_col;

		if (this.options.hscroll == true) {
			this.add_hscroll();
		}
	},

	animate_prices: function animate_prices() {
		if (!this.current_col) this.current_col = 0;

		var last_visible = Math.min(this.current_col + this.options.disp_col - 1, this._items.length - 1);
		var speed = 2000;

		this._items.each(function (_el, i) {
			var height = _el.getAttribute('data-height');

			if (i >= this.current_col && i <= last_visible) {
				var sc = speed * _el.getAttribute('data-price').toInt() / this.max_value,
				    //speed coefficient
				delay = (i >= this.current_col ? i - this.current_col : 0) * 100 + 100;

				(function () {
					var tween = new Fx.Morph(_el, { duration: sc, transition: Fx.Transitions.Bounce.easeOut });
					tween.start({ 'height': [0, height] });
				}).delay(delay);
			} else {
				(function () {
					_el.setStyle('height', height.toInt());
				}).delay(500);
			}
		}.bind(this));

		(function () {
			this.bubble_is_ready = true;

			if (this._indicator && this._indicator.hasClass('visible')) {
				this._indicator.fade('in');
			}
		}).bind(this).delay(speed);
	},

	scroll_prev: function scroll_prev() {
		var prev = this.current_col - this.options.scroll_at_a_time;

		if (prev > 0) {
			this.animate.toElement(this._columns[prev]);
			this.current_col -= this.options.scroll_at_a_time;
		} else {
			this.animate.toElement(this._columns[0]);
			this._arr_prev.addClass('inactive');
			this._ar_l.addClass('inactive');
			this.current_col = 0;
		}

		if (this._dragger) {
			var left = this.dragger_max_left / (this._items.length - this.options.disp_col) * this.current_col;
			this.dragger_fx.start({ 'left': left });
		}

		this._arr_next.removeClass('inactive');
		if (this._ar_r) {
			this._ar_r.removeClass('inactive');
		}
	},

	scroll_next: function scroll_next() {
		var next = this.current_col + this.options.scroll_at_a_time;

		if (next < this.last) {
			this.animate.toElement(this._columns[next]);
			this.current_col += this.options.scroll_at_a_time;
		} else {
			this.animate.toElement(this._columns[this.last]);
			this._arr_next.addClass('inactive');
			this._ar_r.addClass('inactive');
			this.current_col = this.last;
		}

		if (this._dragger) {
			var left = this.dragger_max_left / (this._items.length - this.options.disp_col) * this.current_col;
			this.dragger_fx.start({ 'left': left });
		}

		this._arr_prev.removeClass('inactive');
		if (this._ar_l) {
			this._ar_l.removeClass('inactive');
		}
	},

	add_functionalities: function add_functionalities() {
		var self = this;
		this._element.addEvents({
			'mouseenter': function mouseenter() {
				self._element.addClass('_hover');
			},
			'mouseleave': function mouseleave() {
				self._element.removeClass('_hover');
				self.hide_locked_item();
			}
		});
	},

	hide_locked_item: function hide_locked_item() {
		if (this.locked_item) {
			this.bulb_hide();
			this.locked_item.removeClass('_active');
		}
	}
});
'use strict';

Page.Mia = new Class({
	Extends: Page,

	build: function build() {
		this.parent();
		this.reorder_image();

		var self = this;

		var _slide_gallery = document.getElements('.w_photogallery._slide');
		if (_slide_gallery.length != 0) {
			_slide_gallery.each(function (el) {
				self.add_slide_gallery(el);
			});
		}

		var _thumb_gallery = document.getElements('.w_photogallery._thumbnails');
		if (_thumb_gallery.length != 0) {
			_thumb_gallery.each(function (el) {
				self.add_thumb_gallery(el);
			});
		}

		var _maps = document.getElements('._maps');
		if (_maps.length != 0) {
			_maps.each(function (el) {
				self.add_maps(el);
			});
		}

		var _slides = document.getElements('._slide');
		if (_slides.length != 0) {
			_slides.each(function (el) {
				self.add_slides(el);
			});
		}

		var _voila = document.getElements('.w_voila');
		if (_voila.length != 0) {
			new Voila({
				show_full_size: true
			});
		}

		this.add_management_support();

		// Initialize inquiry form
		this._form = document.getElement('.contact-article .w_form form');
		Core.add_form_support(document.getElement('.contact-article .w_form form'), this.recaptcha_or_not.bind(this), false);

		// Subscribe to the specific event
		window.addEventListener('popup-is-shown', function () {
			this._form = document.querySelector('.cr-popup .contact-article .w_form form');
			if (this._form) {
				Core.add_form_support(this._form, this.recaptcha_or_not.bind(this), false);
			}
		}.bind(this));

		window.addEventListener('popup-is-closed', function () {
			this._form = document.querySelector('.contact-article .w_form form');
			if (this._form) {
				Core.add_form_support(this._form, this.recaptcha_or_not.bind(this), false);
			}
		}.bind(this));

		//this.bottom_bar();
	},

	// bottom_bar: () => {
	// 	let articleElement = document.getElement('._article');
	// 	Core.bottom_bar(articleElement, 800);
	// },

	remove_errors: function remove_errors() {
		this._form.getElements('.form_item').each(function (e) {
			e.removeClass('_failed');
		});
		this._form.getElements('.validation-advice').each(function (e) {
			e.dispose();
		});
	},

	recaptcha_or_not: function recaptcha_or_not() {
		var _this = this;

		window.crRecaptcha.execute(function () {
			_this.handle_form_submit();
		});
	},
	handle_form_submit: function handle_form_submit() {
		this.remove_errors();

		var form_id = this._form.getAttribute("data-id") || this._form.get("id");
		var name_field = this._form.getElement("#" + form_id + "_name");

		if (name_field) {
			var name_value = name_field.value;
			var pattern = /^([^\s]+\s+[^\s]+)(\s+[^\s]*)*$/;

			if (!pattern.test(name_value)) {
				this.add_advice(name_field, 'Error: Enter the full name!');
				return;
			}
		}

		// trim the value of the field to remove extra s
		this._form.getElements('.form_item input[type=text]').each(function (_el) {
			_el.value = _el.value.trim();
		});

		if (this.request && this.request.isRunning()) {
			this.request.cancel();
		}

		var action_url = this._form.get('action');

		if (!action_url) {
			return;
		}

		var data = this._form.toQueryString().trim() + "&ajax=1" + "&" + window.crRecaptcha.getTokensStr("reCaptchaTokens");

		// track side contact submit
		_gaq.push(['_trackEvent', 'Article Inquiry', 'submit', '']);

		this.loader = document.getElement(".w_popup_loader");

		this.request = new Request.JSON({
			url: action_url,
			method: this._form.get('method') || 'post',
			data: data,
			onRequest: this.handle_form_request.bind(this),
			onSuccess: this.handle_form_success.bind(this),
			onFailure: this.handle_form_fail.bind(this)
		}).send();
	},

	// TODO: REFACTORING IS NEEDED
	handle_form_request: function handle_form_request() {
		if (this.loader) {
			this.loader.show();
		}
		this.fireEvent("formRequestStart", [this]);
	},

	handle_form_success: function handle_form_success(data) {
		if (this.loader) {
			this.loader.hide();
		}

		var element;
		var formname = this._form.getAttribute("data-formname");
		var id = this._form.getAttribute("data-id") || this._form.get("id");

		if (element = document.getElements(".contact-article .call.error")) {
			element.hide();
		}

		if (data[formname + "_FORMSUMMARY"] && data[formname + "_FORMSUMMARY"].length && data[formname + "_FORMSUMMARY"][0]["status"]) {
			window.crRecaptcha.setSuccessState(true);

			if (element = document.getElements(".contact-article .head")) {
				element.hide();
			}
			if (element = document.getElements(".contact-article .subhead")) {
				element.hide();
			}

			if (element = document.getElements(".contact-article .w_form")) {
				element.hide();
			}

			element = document.getElements(".contact-article .message");
			if (element) {
				element.set("html", data[formname + "_FORMSUMMARY"][0]["message"]);
			}

			// track gtag
			if (typeof crGtag !== 'undefined' && data && data.RPCFormReusableContact_FORMSUMMARY && data.RPCFormReusableContact_FORMSUMMARY[0] && data.RPCFormReusableContact_FORMSUMMARY[0].status === true && data.RPCFormReusableContact_FORMSUMMARY[0].adWordsCampaign) {
				crGtag.track(data.RPCFormReusableContact_FORMSUMMARY[0].adWordsCampaign.send_to, data.RPCFormReusableContact_FORMSUMMARY[0].adWordsCampaign.value);
			}

			this.fireEvent("formRequestSuccess", [this, data]);
		} else {
			window.crRecaptcha.setSuccessState(false);

			if (Object.keys(data).length == 1) {
				if (element = document.getElements(".contact-article .call.error")) {
					element.set("html", data[formname + "_FORMSUMMARY"][0]["message"]);
					element.show();
				}
			} else {
				var _field;
				if (data[formname + "_name"] && data[formname + "_name"][0].length > 0) {
					_field = this._form.getElement("#" + id + "_name");
					this.add_advice(_field, data[formname + "_name"][0]);
				}
				if (data[formname + "_email"] && data[formname + "_email"][0].length > 0) {
					_field = this._form.getElement("#" + id + "_email");
					this.add_advice(_field, data[formname + "_email"][0]);
				}
				if (data[formname + "_dayphone"] && data[formname + "_dayphone"][0].length > 0) {
					_field = this._form.getElement("#" + id + "_dayphone");
					this.add_advice(_field, data[formname + "_dayphone"][0]);
				}
			}

			this.fireEvent("formRequestFail", [this, data]);
		}
	},

	handle_form_fail: function handle_form_fail() {
		window.crRecaptcha.setSuccessState(false);

		if (this.loader) {
			this.loader.hide();
		}

		this.remove_errors();
		this.fireEvent("formRequestFail", [this]);
	},

	add_slides: function add_slides(el) {
		var strip = el.getElement('.w_marquee');

		if (!strip) return;

		new Marquee(strip, {
			cls: 'strip',

			pause_on_hover: true

		});
	},

	add_maps: function add_maps(_maps) {
		var self = this;
		var _map_links = _maps.getElements('.maps_header .toggle');

		_map_links.each(function (_link) {
			_link.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				if (_maps._active_link == _link) return;

				if (_maps._active_link) {
					_maps._active_link.toggleClass('selected');
					_maps._active_link.map.toggleClass('_active');
				}

				if (!_link.map) {
					_link.map = self['load_' + _link.get('data-map')](_maps);
				} else {
					_link.map.toggleClass('_active');
				}

				_link.toggleClass('selected');
				_maps._active_link = _link;
			});
		}.bind(this));

		if (_maps.get('data-type') == '12') //map view
			_map_links[0].fireEvent('click');else _map_links[1].fireEvent('click');
	},

	load_map_view: function load_map_view(_maps) {
		var _map = _maps.getElement('.w_simplemap');

		if (!_map) return;

		_map.addClass('_active');

		var lat = _map.getAttribute('data-lat');
		var lng = _map.getAttribute('data-lng');

		new SimpleMap(_map, {
			lat: lat,
			lng: lng,
			zoom: parseInt(_map.getAttribute('data-zoom')),
			scrollwheel: false,
			onMapReady: function onMapReady() {
				var iconBase = 'http://maps.google.com/mapfiles/ms/icons/';

				this.add_marker({
					lat: lat,
					lng: lng,
					icon: iconBase + 'red-dot.png'
				});
			}
		});
		return _map;
	},

	load_street_view: function load_street_view(_maps) {
		var _street_view = _maps.getElement('.w_streetview');

		if (!_street_view) return;

		_street_view.addClass('_active');

		new Streetview(_street_view);

		return _street_view;
	},

	add_slide_gallery: function add_slide_gallery(_slide_gallery) {
		new Photogallery(_slide_gallery, {
			width_by_thumbs: 9, //has to be odd or 0 if thumbs are hidden	!!!!!!!!!!!!!!!!!!!!!!
			show_controllers: true, //always display controllers
			no_enlarge_opt: false,
			no_fullscreen_opt: true

			//onFsClose: function(){}
		});
	},

	add_thumb_gallery: function add_thumb_gallery(_thumb_gallery) {
		new Photogallery(_thumb_gallery, {
			width_by_thumbs: 9, //has to be odd or 0 if thumbs are hidden	!!!!!!!!!!!!!!!!!!!!!!
			show_controllers: true, //always display controllers
			no_enlarge_opt: false,
			no_fullscreen_opt: true,
			thumbnail_mode: true
			//onFsClose: function(){}
		});
	},

	reorder_image: function reorder_image() {
		var _old_carter = document.getElement('._article._old_carter');

		if (_old_carter) {
			var _image_tiles = _old_carter.getElements('.tile._n2._image');

			if (_image_tiles) {
				_image_tiles.each(function (_el) {

					var _parent_row = _el.getParent('.row');

					if (_el.hasClass('_last')) {
						_el.addClass('_right');
						_el.inject(_parent_row, 'top');
					} else {
						_el.addClass('_left');
					}
				});
			}
		}
	},

	add_management_support: function add_management_support() {
		var _link = document.getElements('.contact_building a');

		if (!_link) return;

		new ScrollToElement(_link, {
			offset_y: -70
		});
	},

	add_advice: function add_advice(_field, generic_message) {
		if (_field) {
			var _li = _field.getParent("li") || new Element("div");
			var _advice = _field.getNext(".validation-advice") || new Element("div", { "class": "validation-advice" }).inject(_field, "after");
			var msg = _field.get("data-error-exists") || generic_message;
			_li.addClass("_failed");
			_field.addClass("validation-failed");

			_advice.set("html", msg).show();
		}
	}
});
//# sourceMappingURL=mia.js.map
